import callbackRunner from "./callbackRunner";

const { add, run } = callbackRunner(boot);

function boot() {
    window.addEventListener("scroll", onScroll, { passive: true });
}

function onScroll() {
    window.removeEventListener("scroll", onScroll);
    setTimeout(run, 0);
}

export default function loadModuleOnScroll(callback) {
    add(callback);
}
